<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="勋章类型" prop="type" >
        <a-select v-model="form.type" placeholder="请选择勋章">
          <a-select-option :key="0">挑战5公里勋章</a-select-option>
          <a-select-option :key="1">挑战10公里勋章</a-select-option>
          <a-select-option :key="2">达标7天勋章</a-select-option>
          <a-select-option :key="3">达标30天勋章</a-select-option>
          <a-select-option :key="4">达标100天勋章</a-select-option>
          <a-select-option :key="5">达标365天勋章</a-select-option>
          <a-select-option :key="6">累计30万步勋章</a-select-option>
          <a-select-option :key="7">累计100万步勋章</a-select-option>
          <a-select-option :key="8">累计300万步勋章</a-select-option>
          <a-select-option :key="9">累计1000万步勋章</a-select-option>
          <a-select-option :key="10">连续佩戴1个月</a-select-option>
          <a-select-option :key="11">连续佩戴1年</a-select-option>
          <a-select-option :key="12">骑行10公里</a-select-option>
          <a-select-option :key="13">骑行50公里</a-select-option>
          <a-select-option :key="14">骑行百公里</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="封面" prop="cover" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader"
          v-model="form.cover"
          :showUploadList="false"
          :customRequest="handleChange"
        >
          <img v-if="form.cover" :src="form.cover" alt="logo"
               style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMedal, addMedal, updateMedal } from '@/api/joe/medal'
import ossUpload from '@/utils/ossUpload.js'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      uploadLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,

        cover: null,

        targetData: null,

        isOpen: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        cover: null,
        targetData: null,
        isOpen: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMedal({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    handleChange(info) { //上传图片回调
      var that = this;
      this.uploadLoading = true;
      ossUpload.ossUpload(info.file, function (fileName) {
        that.uploadLoading = false;
        console.log(111111);
        console.log(fileName);
        that.form.cover = fileName;
      });
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateMedal(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addMedal(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
